<template>
  <div id="brief">
    <div v-html="content"></div>
  </div>
</template>

<script>
import {reContent} from '@/assets/utility'

export default {
  data() {
    return {
      content: ''
    }
  },
  mounted() {
    this.$store.commit('setAboutTabI', 0)
    this.$axios.post('about/getBlurb').then((res)=>{
      if (res) {
        this.content= reContent(res.content)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  @media only screen and (min-width: 768px) {
    #brief {
      padding: rem(50) 0;
      //border-top: 21px solid #00653E;
    }
  }
  @media only screen and (max-width: 768px) {
    #brief {
      padding: .5rem 0;
    }
  }
</style>
